/* eslint-disable react/require-default-props */
import React from 'react';
import Loader from 'components/atoms/loader';
import AiManagementDataCard from 'components/molecules/ai_management_data_card';
import { usePossibleCompetitorDocuments } from 'hooks/usePossibleCompetitorDocuments';
import { biddingFileHref } from 'services/actions/ai_management_files';
import { dateTimeBr } from 'services/ai_management_format';
import { Content } from './styles';

interface AiManagementCompetitorDocumentsProps {
  biddingId: number | null;
  historicBiddingId: number;
  cnpj: string;
  className?: string;
}

const AiManagementCompetitorDocuments: React.FC<AiManagementCompetitorDocumentsProps> = ({
  biddingId,
  historicBiddingId,
  cnpj,
  className = '',
}) => {
  const { documents, loading, error } = usePossibleCompetitorDocuments(
    biddingId,
    historicBiddingId,
    cnpj,
  );

  const renderBody = () => {
    if (loading) {
      return (
        <div className="py-3">
          <Loader />
        </div>
      );
    }
    if (error) {
      return (
        <div className="px-3 py-3 text-muted">
          Não foi possível carregar os documentos de participação.
        </div>
      );
    }
    if (!documents.length) {
      return (
        <div className="px-3 py-3 text-muted">
          Nenhum documento de participação desta empresa encontrado para esta licitação.
        </div>
      );
    }
    return (
      <Content className="table-responsive">
        <table className="table bg-white mb-0">
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome do arquivo</th>
              <th scope="col" className="text-nowrap">
                Data
              </th>
              <th scope="col">
                <span className="sr-only">Download</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {documents.map((document) => (
              <tr key={document.id}>
                <td className="file-name">{document.nome}</td>
                <td className="text-nowrap">{dateTimeBr(document.data)}</td>
                <td className="text-right text-nowrap">
                  <a
                    href={biddingFileHref(document.download_url)}
                    download={document.nome}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Content>
    );
  };

  return (
    <AiManagementDataCard compact className={className}>
      {renderBody()}
    </AiManagementDataCard>
  );
};

export default AiManagementCompetitorDocuments;
